import { useState, type ReactNode } from "react";
import { CrmSidebar } from "./CrmSidebar";
import { VoicePanel, VoicePanelToggle } from "@/components/voice/VoicePanel";

/**
 * Shell layout: sidebar on the right (RTL natural), main content in the
 * middle, voice panel slides in from the left edge.
 *
 * With `dir="rtl"` and a plain `flex-row`, the inline axis runs right→left.
 * DOM-first <CrmSidebar> sits at the right edge (start), <main> takes the
 * middle, and <VoicePanel> docks against the left edge (end).
 */
export const Layout = ({ children }: { children: ReactNode }) => {
  const [voicePanelOpen, setVoicePanelOpen] = useState(true);
  return (
    <div className="flex flex-row h-svh" dir="rtl">
      <CrmSidebar />
      <main className="relative flex-1 overflow-auto bg-stone-50">
        {!voicePanelOpen && (
          <div className="pointer-events-none absolute inset-x-0 top-0 z-30 flex justify-end px-6 py-4">
            <div className="pointer-events-auto">
              <VoicePanelToggle onClick={() => setVoicePanelOpen(true)} />
            </div>
          </div>
        )}
        <div className="mx-auto max-w-6xl px-6 py-8">{children}</div>
      </main>
      <VoicePanel open={voicePanelOpen} onClose={() => setVoicePanelOpen(false)} />
    </div>
  );
};
